export * from "./syntheticDetailedVehicleReducer";
export * from "./syntheticDetailedVehicleActions";
